import React from "react";
import { StyleSheet, View } from "react-native";

import SectionTitle from "./SectionTitle";

import { type EventOverview } from "@/schemas/events/EventOverview";
import EventGallery from "@/Components/Media/Event/Layout/EventGallery";

type Props = {
  event: EventOverview;
};

function EventPhotos({ event }: Props): React.JSX.Element {
  const styles = StyleSheet.create({
    container: {
      flex: 1,
    },
  });

  return (
    <View style={styles.container}>
      <SectionTitle title="Community Photos" />
      <EventGallery gallery={event.gallery} />
    </View>
  );
}

export default EventPhotos;
